import { Field } from "../config/companies/config";

export const compareTableValues = (
  aValue: unknown,
  bValue: unknown,
  field?: Field,
): number => {
  const sortRankMap = field?.sortRankMap;

  if (sortRankMap) {
    const aRank = sortRankMap[aValue as string];
    const bRank = sortRankMap[bValue as string];
    const diff = aRank - bRank;

    return diff;
  }

  if (typeof aValue === "string" && typeof bValue === "string") {
    const caseInsensitive = aValue
      .toLowerCase()
      .localeCompare(bValue.toLowerCase());
    return caseInsensitive !== 0
      ? caseInsensitive
      : aValue.localeCompare(bValue);
  }

  if (typeof aValue === "number" && typeof bValue === "number") {
    return aValue - bValue;
  }

  return String(aValue).localeCompare(String(bValue));
};

export const getComparableValue = (val: any) => {
  if (!val) return 0;
  if (val.seconds !== undefined) return val.seconds;
  if (val instanceof Date) return val.getTime();
  const parsed = Date.parse(val);
  return isNaN(parsed) ? val : parsed;
};
